import type { LabelHTMLAttributes, ReactNode } from 'react';
import styled, { css } from 'styled-components';

const LabelStyle = styled.label<{ $required?: boolean }>`
  display: inline-block;
  color: ${({ theme }) => theme.colors.text.primary};

  ${({ $required }) =>
    $required &&
    css`
      &::after {
        content: ' *';
        color: ${({ theme }) => theme.palette.danger[1]};
      }
    `}
`;

type LabelProps = LabelHTMLAttributes<HTMLLabelElement> & {
  children?: ReactNode;
  required?: boolean;
};

const Label = ({ children, required, ...props }: LabelProps) => {
  return (
    <LabelStyle {...props} $required={required}>
      {children}
    </LabelStyle>
  );
};

export default Label;
